import { Model, type ModelProps } from '@/infra/model'
import { observable, computed } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { Id } from '@/infra/id'

/**
 * What a billing transaction was for.
 */
export type BillingTransactionType =
  | 'Deposit'
  | 'Purchase'
  | 'Bonus'
  | 'AdminAdd'
  | 'AdminRemove'
  | 'Refund'
  | 'Payout'
  | 'Unknown'

export type BillingTransactionProps = ModelProps<BillingTransaction>

/**
 * A charge, refund or payout on a billing method.
 */
export class BillingTransaction extends Model<BillingTransaction> {
  id = Id.none

  @observable accessor amount = 0
  @observable accessor billingMethodId = Id.none
  @observable accessor payoutMethodId = Id.none
  @observable accessor dateCreated = unixEpoch()
  @observable accessor transactionType: BillingTransactionType = 'Purchase'
  @observable accessor refundTargetTransaction = ''
  @observable accessor version = 0
  @observable accessor receiptUrl: string | null = null

  @computed
  get isPurchase() {
    return this.transactionType === 'Purchase'
  }

  @computed
  get isRefund() {
    return this.transactionType === 'Refund'
  }
}
